//DownloadCenter - Search Query Parameters
export const DOWNLOAD_CENTER_SEARCH_PARAMETER_SORT_TYPE = 'download_center_search_parameter_sort_type';
export const DOWNLOAD_CENTER_SEARCH_PARAMETER_SORT_ORDER = 'download_center_search_parameter_search_order';
export const DOWNLOAD_CENTER_SEARCH_PARAMETER_PAGE_SIZE = 'download_center_search_parameter_page_size';
export const DOWNLOAD_CENTER_SEARCH_PARAMETER_RECENTLY_ADDED = 'download_center_search_parameter_recently_added';
export const DOWNLOAD_CENTER_SEARCH_PAGE_SIZE_OPTIONS = 'download_center_search_page_size_options';

//DownloadCenter
export const DOWNLOAD_CENTER_BREADCRUMB = 'download_center_breadcrumb';
export const DOWNLOAD_CENTER_ITEMS_HEADER = 'download_center_items_header';
export const DOWNLOAD_CENTER_ITEMS_FOOTER = 'download_center_items_footer';
export const DOWNLOAD_CENTER_ITEMS_VIEW = 'download_center_items_view';
export const DOWNLOAD_CENTER_MAIN_ACTION = 'download_center_main_action';
//DownloadCenter - Mobile
export const DOWNLOAD_CENTER_MOBILE_BREADCRUMB = 'download_center_mobile_breadcrumb';
export const DOWNLOAD_CENTER_MOBILE_ITEMS_HEADER = 'download_center_mobile_items_header';
export const DOWNLOAD_CENTER_MOBILE_ITEMS_FOOTER = 'download_center_mobile_items_footer';
export const DOWNLOAD_CENTER_MOBILE_ITEMS_VIEW = 'download_center_mobile_items_view';
export const DOWNLOAD_CENTER_MOBILE_MAIN_ACTION = 'download_center_mobile_main_action';

//AddItemMenu
export const ADD_ITEM_MENU_MAIN_ACTION_CREATE_FOLDER = 'add_item_menu_main_action_create_folder';
export const ADD_ITEM_MENU_MAIN_ACTION_UPLOAD_FILE = 'add_item_menu_main_action_upload_file';
//AddItemMenu - Mobile
export const ADD_ITEM_MENU_MOBILE_MAIN_ACTION_CREATE_FOLDER = 'add_item_menu_mobile_main_action_create_folder';
export const ADD_ITEM_MENU_MOBILE_MAIN_ACTION_UPLOAD_FILE = 'add_item_menu_mobile_main_action_upload_file';

//SearchBar
export const SEARCH_BAR = 'search_bar';
export const SEARCH_BAR_SEARCH_TERM = 'search_bar_search_term';
export const SEARCH_BAR_FILTER_CONTAINER = 'search_bar_filter_container';
export const SEARCH_BAR_FILTER_CONTAINER_TOTAL_COUNT = 'search_bar_filter_container_total_count';
export const SEARCH_BAR_FILTER_CONTAINER_FILTERS = 'search_bar_filter_container_filters';
export const SEARCH_BAR_FILTER_CONTAINER_RECENTLY_ADDED_FILTER = 'search_bar_filter_container_recently_added_filter';
export const SEARCH_BAR_FILTER_CONTAINER_FAVORITES_FILTER = 'search_bar_filter_container_favorites_filter';
export const SEARCH_BAR_FILTER_CONTAINER_PUBLIC_ACCESS_FILTER = 'search_bar_filter_container_public_access_filter';
export const SEARCH_BAR_FILTER_CONTAINER_SORT_ORDER_FILTER = 'search_bar_filter_container_sort_order_filter';
export const SEARCH_BAR_FILTER_CONTAINER_FILTER_SELECTION = 'search_bar_filter_container_filter_selection';
export const SEARCH_BAR_FILTER_CONTAINER_OBJECT_TYPE_FILTER = 'search_bar_filter_container_object_type_filter';
export const SEARCH_BAR_FILTER_CONTAINER_FILE_TYPE_FILTER = 'search_bar_filter_container_file_type_filter';
//SearchBar - Mobile
export const SEARCH_BAR_MOBILE = 'search_bar_mobile';
export const SEARCH_BAR_MOBILE_SEARCH_TERM = 'search_bar_mobile_search_term';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER = 'search_bar_mobile_filter_container';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_TOTAL_COUNT = 'search_bar_mobile_filter_container_total_count';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_FILTERS = 'search_bar_mobile_filter_container_filters';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_RECENTLY_ADDED_FILTER = 'search_bar_mobile_filter_container_recently_added_filter';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_FAVORITES_FILTER = 'search_bar_mobile_filter_container_favorites_filter';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_PUBLIC_ACCESS_FILTER = 'search_bar_mobile_filter_container_public_access_filter';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_SORT_ORDER_FILTER = 'search_bar_mobile_filter_container_sort_order_filter';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_FILTER_SELECTION = 'search_bar_mobile_filter_container_filter_selection';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_OBJECT_TYPE_FILTER = 'search_bar_mobile_filter_container_object_type_filter';
export const SEARCH_BAR_MOBILE_FILTER_CONTAINER_FILE_TYPE_FILTER = 'search_bar_mobile_filter_container_file_type_filter';

//ItemsHeader
export const ITEMS_HEADER_LAYOUTS = 'items_header_layouts';
export const ITEMS_HEADER_LAYOUT = 'items_header_layout';
export const ITEMS_HEADER_RESULT_INFO = 'items_header_result_info';
export const ITEMS_HEADER_PAGE_INDICATOR = 'items_header_page_indicator';
export const ITEMS_HEADER_PAGE_SIZE = 'items_header_page_size';
export const ITEMS_HEADER_LAYOUT_GRID = 'items_header_layout_grid';
export const ITEMS_HEADER_LAYOUT_LIST = 'items_header_layout_list';
export const ITEMS_HEADER_LAYOUT_TABLE = 'items_header_layout_table';
export const ITEMS_HEADER_LAYOUT_TABLE_HEAD = 'items_header_layout_table_head';
export const ITEMS_HEADER_LAYOUT_TABLE_BODY = 'items_header_layout_table_body';
//ItemsHeader - Mobile
export const ITEMS_HEADER_MOBILE_LAYOUTS = 'items_header_mobile_layouts';
export const ITEMS_HEADER_MOBILE_LAYOUT = 'items_header_mobile_layout';
export const ITEMS_HEADER_MOBILE_RESULT_INFO = 'items_header_mobile_result_info';
export const ITEMS_HEADER_MOBILE_PAGE_INDICATOR = 'items_header_mobile_page_indicator';
export const ITEMS_HEADER_MOBILE_PAGE_SIZE = 'items_header_mobile_page_size';
export const ITEMS_HEADER_MOBILE_LAYOUT_GRID = 'items_header_mobile_layout_grid';
export const ITEMS_HEADER_MOBILE_LAYOUT_LIST = 'items_header_mobile_layout_list';
export const ITEMS_HEADER_MOBILE_LAYOUT_TABLE = 'items_header_mobile_layout_table';
export const ITEMS_HEADER_MOBILE_LAYOUT_TABLE_HEAD = 'items_header_mobile_layout_table_head';
export const ITEMS_HEADER_MOBILE_LAYOUT_TABLE_BODY = 'items_header_mobile_layout_table_body';

//ItemsFooter
export const ITEMS_FOOTER_PAGE_INDICATOR = 'items_footer_page_indicator';
export const ITEMS_FOOTER_PREVIOUS_PAGE = 'items_footer_previous_page';
export const ITEMS_FOOTER_NEXT_PAGE = 'items_footer_next_page';
//ItemsFooter - Mobile
export const ITEMS_FOOTER_MOBILE_PAGE_INDICATOR = 'items_footer_mobile_page_indicator';
export const ITEMS_FOOTER_MOBILE_PREVIOUS_PAGE = 'items_footer_mobile_previous_page';
export const ITEMS_FOOTER_MOBILE_NEXT_PAGE = 'items_footer_mobile_next_page';

//ItemsView
export const ITEMS_VIEW_THUMBNAIL = 'items_view_thumbnail';
export const ITEMS_VIEW_NAME = 'items_view_name';
export const ITEMS_VIEW_DESCRIPTION = 'items_view_description';
export const ITEMS_VIEW_FILE_TYPE = 'items_view_file_type';
export const ITEMS_VIEW_DATE_CREATED = 'items_view_date_created';
export const ITEMS_VIEW_TOTAL_SIZE = 'items_view_total_size';
export const ITEMS_VIEW_TAGS = 'items_view_tags';
export const ITEMS_VIEW_USER_LABELS = 'items_view_user_labels';
export const ITEMS_VIEW_PUBLIC_ACCESS = 'items_view_public_access'
export const ITEMS_VIEW_MERGE_FLEXIBLE_DATA_INTO_NAME = 'items_view_merge_flexible_data_into_name';
//ItemsView - Mobile
export const ITEMS_VIEW_MOBILE_THUMBNAIL = 'items_view_mobile_thumbnail';
export const ITEMS_VIEW_MOBILE_NAME = 'items_view_mobile_name';
export const ITEMS_VIEW_MOBILE_DESCRIPTION = 'items_view_mobile_description';
export const ITEMS_VIEW_MOBILE_FILE_TYPE = 'items_view_mobile_file_type';
export const ITEMS_VIEW_MOBILE_DATE_CREATED = 'items_view_mobile_date_created';
export const ITEMS_VIEW_MOBILE_TOTAL_SIZE = 'items_view_mobile_total_size';
export const ITEMS_VIEW_MOBILE_TAGS = 'items_view_mobile_tags';
export const ITEMS_VIEW_MOBILE_USER_LABELS = 'items_view_user_mobile_labels';
export const ITEMS_VIEW_MOBILE_PUBLIC_ACCESS = 'items_view_mobile_public_access';
export const ITEMS_VIEW_MOBILE_MERGE_FLEXIBLE_DATA_INTO_NAME = 'items_view_mobile_merge_flexible_data_into_name';

//ItemsView - Command Actions
export const ITEMS_VIEW_COMMAND_ACTION = 'items_view_command_action';
export const ITEMS_VIEW_COMMAND_ACTION_NAVIGATE = 'items_view_command_action_navigate';
export const ITEMS_VIEW_COMMAND_ACTION_EDIT = 'items_view_command_action_edit';
export const ITEMS_VIEW_COMMAND_ACTION_DELETE = 'items_view_command_action_delete';
export const ITEMS_VIEW_COMMAND_ACTION_VIEW = 'items_view_command_action_view';
export const ITEMS_VIEW_COMMAND_ACTION_FAVORITE = 'items_view_command_action_favorite';
export const ITEMS_VIEW_COMMAND_ACTION_PREVIEW = 'items_view_command_action_preview';
export const ITEMS_VIEW_COMMAND_ACTION_DOWNLOAD = 'items_view_command_action_download';
export const ITEMS_VIEW_COMMAND_ACTION_COPY_URL = 'items_view_command_action_copy_url';
export const ITEMS_VIEW_COMMAND_ACTION_MORE = 'items_view_command_action_more';

//ItemsView - Command Actions - In Row Menu
export const ITEMS_VIEW_GRID_COMMAND_MAX_ACTION_BUTTONS_IN_ROW = 'items_view_grid_command_max_action_buttons_in_row';
export const ITEMS_VIEW_LIST_COMMAND_MAX_ACTION_BUTTONS_IN_ROW = 'items_view_list_command_max_action_buttons_in_row';
export const ITEMS_VIEW_TABLE_COMMAND_MAX_ACTION_BUTTONS_IN_ROW = 'items_view_table_command_max_action_buttons_in_row';
export const ITEMS_VIEW_GRID_COMMAND_ACTION_BUTTONS_IN_ROW_LIST = 'items_view_grid_command_action_buttons_in_row_list';
export const ITEMS_VIEW_LIST_COMMAND_ACTION_BUTTONS_IN_ROW_LIST = 'items_view_list_command_action_buttons_in_row_list';
export const ITEMS_VIEW_TABLE_COMMAND_ACTION_BUTTONS_IN_ROW_LIST = 'items_view_table_command_action_buttons_in_row_list';
//ItemsView - Command Actions - In Row Menu - Mobile
export const ITEMS_VIEW_GRID_COMMAND_MOBILE_MAX_ACTION_BUTTONS_IN_ROW = 'items_view_grid_command_mobile_max_action_buttons_in_row';
export const ITEMS_VIEW_LIST_COMMAND_MOBILE_MAX_ACTION_BUTTONS_IN_ROW = 'items_view_list_command_mobile_max_action_buttons_in_row';
export const ITEMS_VIEW_TABLE_COMMAND_MOBILE_MAX_ACTION_BUTTONS_IN_ROW = 'items_view_table_command_mobile_max_action_buttons_in_row';
export const ITEMS_VIEW_GRID_COMMAND_MOBILE_ACTION_BUTTONS_IN_ROW_LIST = 'items_view_grid_command_mobile_action_buttons_in_row_list';
export const ITEMS_VIEW_LIST_COMMAND_MOBILE_ACTION_BUTTONS_IN_ROW_LIST = 'items_view_list_command_mobile_action_buttons_in_row_list';
export const ITEMS_VIEW_TABLE_COMMAND_MOBILE_ACTION_BUTTONS_IN_ROW_LIST = 'items_view_table_command_mobile_action_buttons_in_row_list';

//ItemsView - Command Actions - In More Options Popover Menu
export const ITEMS_VIEW_GRID_COMMAND_ACTION_BUTTONS_IN_MORE_LIST = 'items_view_grid_command_action_buttons_in_more_list';
export const ITEMS_VIEW_LIST_COMMAND_ACTION_BUTTONS_IN_MORE_LIST = 'items_view_list_command_action_buttons_in_more_list';
export const ITEMS_VIEW_TABLE_COMMAND_ACTION_BUTTONS_IN_MORE_LIST = 'items_view_table_command_action_buttons_in_more_list';
//ItemsView - Command Actions - In More Options Popover Menu - Mobile
export const ITEMS_VIEW_GRID_COMMAND_MOBILE_ACTION_BUTTONS_IN_MORE_LIST = 'items_view_grid_command_mobile_action_buttons_in_more_list';
export const ITEMS_VIEW_LIST_COMMAND_MOBILE_ACTION_BUTTONS_IN_MORE_LIST = 'items_view_list_command_mobile_action_buttons_in_more_list';
export const ITEMS_VIEW_TABLE_COMMAND_MOBILE_ACTION_BUTTONS_IN_MORE_LIST = 'items_view_table_command_mobile_action_buttons_in_more_list';

//ItemsView - Event Actions
export const ITEMS_VIEW_FOLDER_ON_CLICK_COMMAND_ACTION = 'items_view_folder_on_click_command_action';
export const ITEMS_VIEW_FILE_ON_CLICK_COMMAND_ACTION = 'items_view_file_on_click_command_action';
//ItemsView - Event Actions - Mobile
export const ITEMS_VIEW_MOBILE_FOLDER_ON_CLICK_COMMAND_ACTION = 'items_view_mobile_folder_on_click_command_action';
export const ITEMS_VIEW_MOBILE_FILE_ON_CLICK_COMMAND_ACTION = 'items_view_mobile_file_on_click_command_action';

//PageIndicator
export const PAGE_INDICATOR_MIN_VISIBLE_ITEMS = 'page_indicator_min_visible_items';
//PageIndicator - Mobile
export const PAGE_INDICATOR_MOBILE_MIN_VISIBLE_ITEMS = 'page_indicator_mobile_min_visible_items';

//Custom Filters
export const MAIN_FILTERS = 'main_filters';
export const SUB_FILTERS = 'sub_filters';
export const PREDEFINED_FILTERS = 'predefined_filters';
